<template>    
    <v-card>
        <!-- Titulo del dialogo -->
        <v-card-title>
            Agregar Compra
        </v-card-title>
        <v-divider></v-divider>
            <!-- Formulario -->
        <v-form ref="form">

            <v-stepper v-model="e1" class="elevation-0">
                <v-stepper-header class="elevation-0">
                    <v-stepper-step style="font-weight:bolder!important;" :complete="e1 > 1" step="1"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step style="font-weight:bolder!important;" step="2"></v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1" class="py-0">
                        <v-row class="py-0 px-0 mx-0">
                            <v-col cols="12" sm="6" md="4">
                                <v-menu v-model="datePicker1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="editedItem.date" label="Fecha" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker color="primary" v-model="editedItem.date" @input="datePicker1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select :items="series" v-model="editedItem.serie" label="Serie"></v-select>
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.invoice" label="Numero de Factura"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">

                                <v-autocomplete clearable v-model="editedItem.provider_id" :items="providerList" label="Proveedor" item-text="name" item-value="id">
                                    <template slot="no-data">
                                        <div class="px-6 pt-3">
                                            No existen proveedores relacionados.
                                            <v-text-field v-model="createProvider.name" label="Proveedor" append-icon="mdi-plus" @click:append="saveProvider()"></v-text-field>
                                        </div>
                                    </template>
                                </v-autocomplete>



                                <v-menu v-model="datePicker2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="editedItem.due_date" label="Fecha de vencimiento" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker color="primary" v-model="editedItem.due_date" @input="datePicker2 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-menu top offset-x>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn style="font-size:12px;" text v-bind="attrs" v-on="on">
                                            <v-icon class="mr-2">mdi-attachment</v-icon> Adjuntar PDF
                                        </v-btn>
                                    </template>
                                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess" v-on:vdropzone-error="uploadError" v-on:vdropzone-removed-file="fileRemoved"/>
                                </v-menu>
                                <v-menu top offset-x>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn style="font-size:12px;" text v-bind="attrs" v-on="on">
                                            <v-icon class="mr-2">mdi-attachment</v-icon> Adjuntar Evidencia
                                        </v-btn>
                                    </template>
                                    <vue-dropzone ref="myVueDropzone2" id="dropzone2" :options="dropzoneOptions" :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess2" v-on:vdropzone-error="uploadError" v-on:vdropzone-removed-file="fileRemoved"/>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="8">
                                <v-textarea v-model="editedItem.notes" label="Descripcion"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-stepper-content>
                    <v-stepper-content  step="2" class="py-0">
                        <v-row style="background-color: #94949417;" class="px-2 ma-0 py-2" v-for="(item,k) in editedItem.products" :key="k">
                            <v-col cols="1" class="py-0 my-0">
                                <div style="font-size: 10px;
                                background: #1876d2;
                                padding: 1px 2px;
                                color: white;
                                font-weight: 600;
                                display: inline;
                                position: absolute;
                                margin-left: -27px;
                                margin-top:10px;
                                border-radius:10px;
                                min-width:16px;
                                text-align:center;">{{k+1}}</div>
                                <v-text-field type=number v-model="item.quantity" label="Cantidad"></v-text-field>
                            </v-col>
                            <v-col cols="3" class="py-0 my-0">

                                <!--v-autocomplete v-if="liga == 'https://suministros.uno/'" :items="itemLists" v-model="item.item_id" item-text="name" item-value="id" label="Producto"></v-autocomplete-->

                                <div v-if="item.item_id==''">
                                    <v-text-field v-model="searchItems" @input="debounceSearch" :loading="isLoadingItems" label="Producto" placeholder="Escribe para buscar"></v-text-field>
                                    <v-list v-if="searchItems!=''&&!isLoadingItems" class="py-0" style="position: absolute; z-index: 999; height: 130px; overflow-y: scroll; margin-top: -21px; box-shadow: 0px 0px 2px 0px #0000004a; cursor:pointer;">
                                        <v-list-item v-for="(product, index) in itemsList" :key="index" style="border-bottom:1px solid #00000021;" class="item-hover"  @click="item.item_id=product.id, searchItems=''">
                                            <div>
                                                <div>{{product.name}}</div>
                                                <div v-if="product.latest_unit_cost !== null && product.latest_unit_cost !== undefined" style="font-size:12px; color:#616161;">
                                                    Último costo: {{ formatMoney(product.latest_unit_cost) }}
                                                </div>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </div>


                                <div class="mt-5" v-else>
                                    {{ selectedProductMeta(item).name }}
                                    <v-btn @click="removeEmpties(), item.item_id = ''" icon>
                                        <v-icon small>mdi-pencil</v-icon>
                                    </v-btn>
                                    <div
                                        v-if="selectedProductMeta(item).latest_unit_cost !== null && selectedProductMeta(item).latest_unit_cost !== undefined"
                                        style="font-size:12px; color:#616161;"
                                    >
                                        Último costo: {{ formatMoney(selectedProductMeta(item).latest_unit_cost) }}
                                    </div>
                                </div>


                            </v-col>
                            <v-col cols="2" class="py-0 my-0" v-if="item.item!=''">
                                <v-text-field
                                    v-model="item.original_cost"
                                    type="number"
                                    step="0.0001"
                                    prefix="$"
                                    suffix="c/u"
                                    label="Costo Unitario"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" class="py-0 my-0" v-if="item.item!=''">
                                <v-text-field v-model="item.discount" suffix="%" label="Descuento"></v-text-field>
                            </v-col>
                            <v-col cols="1" class="py-0 my-0" v-if="item.item!=''">
                                <v-checkbox
                                    v-model="item.apply_iva"
                                    hide-details
                                    dense
                                    label="IVA"
                                    class="mt-4"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="2" class="py-0 my-0 pt-3" v-if="item.item!=''" style="font-size:12px; line-height:20px;">
                                CU/desc: <strong>{{ formatUnitCost(discountedUnitCost(item)) }}</strong>
                                <br/>
                                Costo Total: <strong>{{ formatMoney(lineSubtotal(item)) }}</strong>
                            </v-col>
                            <v-col cols="1">
                                <v-icon @click="remove(k)" v-show="k || ( !k && editedItem.products.length > 1)" color="red">mdi-close</v-icon>
                                <v-icon @click="add(k)" v-show="k == editedItem.products.length-1" color="primary" :disabled="item.item_id==''">mdi-plus</v-icon>
                            </v-col>
                        </v-row>

                        <v-row class="px-2 ma-0 py-2 mt-2 calculos">
                            <v-col cols="3" class="py-0 my-0">
                                <v-text-field label="Porcentaje de IVA" v-model="editedItem.iva_percentage"></v-text-field>
                                <span style="font-size:14px; transform:translateY(-10px)!important:">Monto IVA: {{amount_iva.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</span>
                            </v-col>
                            <v-col cols="3" class="py-0 my-0">
                                <v-text-field label="Porcentaje de ISR" v-model="editedItem.isr_percentage"></v-text-field>
                                <span style="font-size:14px; transform:translateY(-10px)!important:">Monto ISR: {{amount_isr.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</span>
                            </v-col>
                            <v-col cols="3" class="pt-0">
                                <v-text-field
                                    v-model="editedItem.global_discount"
                                    suffix="%"
                                    label="Descuento global"
                                    hint="Se aplica a todos los productos"
                                    persistent-hint
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" class="py-0 my-0">
                                <div class="shopping-summary-line">
                                    <span>Sin desc. s/IVA</span>
                                    <strong>{{ formatMoney(subtotalBeforeDiscount) }}</strong>
                                </div>
                                <div class="shopping-summary-line">
                                    <span>IVA s/desc.</span>
                                    <strong>{{ formatMoney(amountIvaBeforeDiscount) }}</strong>
                                </div>
                                <div class="shopping-summary-note">
                                    Base IVA s/desc: {{ formatMoney(taxableSubtotalBeforeDiscount) }} x {{ isNull(editedItem.iva_percentage) }}%
                                </div>
                                <div class="shopping-summary-line">
                                    <span>Sin desc. c/IVA</span>
                                    <strong>{{ formatMoney(totalWithoutDiscountWithIva) }}</strong>
                                </div>
                                <div class="shopping-summary-line shopping-summary-line--discount">
                                    <span>Descuento</span>
                                    <strong>-{{ formatMoney(discountTotal) }}</strong>
                                </div>
                                <div class="shopping-summary-line">
                                    <span>Con desc. s/IVA</span>
                                    <strong>{{ formatMoney(subtotal) }}</strong>
                                </div>
                                <div class="shopping-summary-line">
                                    <span>IVA c/desc.</span>
                                    <strong>{{ formatMoney(amount_iva) }}</strong>
                                </div>
                                <div class="shopping-summary-note">
                                    Base IVA c/desc: {{ formatMoney(taxableSubtotal) }} x {{ isNull(editedItem.iva_percentage) }}%
                                </div>
                                <div class="shopping-summary-line">
                                    <span>Con desc. c/IVA</span>
                                    <strong>{{ formatMoney(totalWithDiscountWithIva) }}</strong>
                                </div>
                                <div class="shopping-summary-line" v-if="amount_isr > 0">
                                    <span>ISR</span>
                                    <strong>-{{ formatMoney(amount_isr) }}</strong>
                                </div>
                                <div class="shopping-summary-line shopping-summary-line--final">
                                    <span>Total final</span>
                                    <strong>{{ formatMoney(amount_total) }}</strong>
                                </div>
                            </v-col>
                        </v-row>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>




            <v-card-actions class="pt-4">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>

                <v-btn color="blue darken-1" text  v-if="e1>1" @click="e1 = e1-1">
                    <v-icon v-if="!isMobile()">mdi-chevron-left</v-icon>
                    Regresar
                </v-btn>
                <v-btn color="blue darken-1" text  v-if="e1!=2" @click="e1 = e1+1">
                    Siguiente
                    <v-icon v-if="!isMobile()">mdi-chevron-right</v-icon>
                </v-btn>

                <v-btn color="blue darken-1" text :loading="gris" :disabled="gris || valid" @click="save">Guardar</v-btn>
            </v-card-actions>
        </v-form>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-card>
</template>
<script>
import debounce from 'lodash/debounce';
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import axios from "axios";
export default {
    props: {
        prefill: {
            type: Object,
            default: null
        }
    },
    components: {
        vueDropzone: vue2Dropzone
    },  
    data:()=>({ 
        pdf:'',
        xml:'',
        e1: 1,
        createProvider:{
            name:'',
        }, 
        dropzoneOptions: {
            url: process.env.VUE_APP_BACKEND_ROUTE + "api/v1/quotation/files",
            addRemoveLinks: true,
            maxFiles: 1,

        },
        series:['Serie A',  'Serie B', 'Inversiones'],
        datePicker1:false,
        datePicker2:false,
        editedItem: {
            date:'',
            serie:'',
            provider_id:'',
            invoice:'',
            due_date:'',
            notes:'',
            pdf:'',
            xml:'',
            created_by_user_id:'',
            last_updated_by_user_id:'',
            global_discount:'',
            products:[{
                shopping_id:'',
                item_id:'',
                quantity:1,
                unit_cost:'',
                created_by_user_id:'',
                last_updated_by_user_id:'',
                discount:'',
                original_cost:'',
                apply_iva:true
            }],
            iva_percentage:'',
            isr_percentage:''
        },
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        gris:false,
        rules: {
            required: value => !!value || 'Campo requerido',
        },
        itemsList:[],
        isLoadingItems:false,
        searchItems:'',
        debounceSearch: null
    }),
    watch: {
        prefill: {
            handler(value) {
                this.applyPrefill(value);
            },
            deep: true,
            immediate: true
        },
        'editedItem.global_discount'() {
            this.applyGlobalDiscount();
        }
    },
    computed:{
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        valid(){
            if(this.editedItem.provider_id!=''&&this.editedItem.provider_id!=null&&this.editedItem.provider_id!=undefined){
                if(process.env.VUE_APP_BACKEND_ROUTE == "https://suministros.uno/"){
                    if(this.editedItem.products[0].item_id!=''){
                        return false
                    }else{
                        return true
                    }
                }else{
                    return false
                }
            }else{
                return true
            }
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
        providerList:{
            get(){
                return this.$store.state.provider.providers
            }
        },
        subtotalBeforeDiscount(){
            return this.round2((this.editedItem.products || []).reduce((sum, product) => {
                const originalCost = Number(product.original_cost || 0)
                const quantity = Number(product.quantity || 0)
                return sum + (originalCost * quantity)
            }, 0))
        },
        subtotal(){
            var sum = 0
            for(var i=0; i<this.editedItem.products.length; i++){
                sum = sum + this.lineSubtotal(this.editedItem.products[i])
            }
            return this.round2(sum)
        },
        taxableSubtotalBeforeDiscount(){
            return this.round2((this.editedItem.products || []).reduce((sum, product) => {
                const appliesIva = product.apply_iva !== false && product.apply_iva !== 0 && product.apply_iva !== '0'
                if (!appliesIva) {
                    return sum
                }
                const originalCost = Number(product.original_cost || 0)
                const quantity = Number(product.quantity || 0)
                return sum + (originalCost * quantity)
            }, 0))
        },
        taxableSubtotal(){
            return this.round2((this.editedItem.products || []).reduce((sum, product) => {
                const appliesIva = product.apply_iva !== false && product.apply_iva !== 0 && product.apply_iva !== '0'
                if (!appliesIva) {
                    return sum
                }
                return sum + this.lineSubtotal(product)
            }, 0))
        },
        discountTotal(){
            return this.round2(Math.max(this.subtotalBeforeDiscount - this.subtotal, 0))
        },
        amountIvaBeforeDiscount(){
            return this.round2((this.taxableSubtotalBeforeDiscount/100)*this.isNull(this.editedItem.iva_percentage))
        },
        amount_iva(){
            return this.round2((this.taxableSubtotal/100)*this.isNull(this.editedItem.iva_percentage))
        },
        amount_isr(){
            return this.round2((this.subtotal/100)*this.isNull(this.editedItem.isr_percentage))
        },
        totalWithoutDiscountWithIva(){
            return this.round2(this.subtotalBeforeDiscount + this.amountIvaBeforeDiscount)
        },
        totalWithDiscountWithIva(){
            return this.round2(this.subtotal + this.amount_iva)
        },
        amount_total(){
            return this.round2(this.subtotal + this.amount_iva - this.amount_isr)
        },
    },
    methods:{
        createProduct(product = {}) {
            return {
                shopping_id:'',
                item_id:'',
                quantity:1,
                unit_cost:'',
                created_by_user_id:'',
                last_updated_by_user_id:'',
                discount:this.isNull(this.editedItem?.global_discount),
                original_cost:'',
                apply_iva:true,
                ...product
            };
        },
        applyGlobalDiscount() {
            const discount = this.isNull(this.editedItem.global_discount);
            this.editedItem.products = this.editedItem.products.map(product => ({
                ...product,
                discount
            }));
        },
        applyPrefill(prefill) {
            if (!prefill) {
                return;
            }
            const baseProducts = Array.isArray(prefill.products) && prefill.products.length
                ? prefill.products.map((product) => this.createProduct(product))
                : this.editedItem.products;

            this.editedItem = {
                ...this.editedItem,
                date: prefill.date ?? this.editedItem.date,
                due_date: prefill.due_date ?? this.editedItem.due_date,
                provider_id: prefill.provider_id ?? this.editedItem.provider_id,
                notes: prefill.notes ?? this.editedItem.notes,
                serie: prefill.serie ?? this.editedItem.serie,
                iva_percentage: prefill.iva_percentage ?? this.editedItem.iva_percentage,
                isr_percentage: prefill.isr_percentage ?? this.editedItem.isr_percentage,
                global_discount: prefill.global_discount ?? this.editedItem.global_discount,
                products: baseProducts
            };
            this.applyGlobalDiscount();
            this.e1 = 1;
        },
        searchData(){
            this.isLoadingItems = true;
            const searchTerm = this.searchItems.trim();
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/item/pos?filter[pos]=' + this.searchItems + '&itemsPerPage=15')
            .then(response => {
                if (this.searchItems === searchTerm) {
                    this.itemsList = response.data.data.map(id => ({
                        id: JSON.stringify({
                            id: id.id,
                            name: id.name,
                            latest_unit_cost: id.latestShopping?.unit_cost ?? null
                        }),
                        name: id.name,
                        latest_unit_cost: id.latestShopping?.unit_cost ?? null
                    }));
                    this.isLoadingItems = false;
                }
            })
        },
        selectedProductMeta(item){
            try{
                const parsed = typeof item?.item_id === 'string'
                    ? JSON.parse(item.item_id)
                    : (typeof item?.item_id === 'object' ? item.item_id : {})

                return {
                    ...parsed,
                    latest_unit_cost: parsed?.latest_unit_cost ?? item?.original_cost ?? null
                }
            }catch(error){
                return {
                    name: '',
                    latest_unit_cost: item?.original_cost ?? null
                }
            }
        },
        formatMoney(value){
            return Number(value || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
        },
        formatUnitCost(value){
            return Number(value || 0).toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 4,
                maximumFractionDigits: 4
            })
        },
        round(value, decimals = 2){
            const factor = 10 ** decimals
            return Math.round((Number(value || 0) + Number.EPSILON) * factor) / factor
        },
        round2(value){
            return this.round(value, 2)
        },
        round4(value){
            return this.round(value, 4)
        },
        discountedUnitCost(product){
            const originalCost = Number(product?.original_cost || 0)
            const discount = Number(this.isNull(product?.discount) || 0)
            return this.round4(originalCost - ((originalCost / 100) * discount))
        },
        lineSubtotal(product){
            const quantity = Number(product?.quantity || 0)
            return this.discountedUnitCost(product) * quantity
        },
        removeEmpties(){
            for(var i=0; i<this.editedItem.products.length; i++){
                if(this.editedItem.products[i].item_id == ''){
                    this.editedItem.products.splice(i, 1);
                }
            }
        },
        isNull(value){
            if(value==null||value==undefined||value==''){
                return 0
            }else{
                return value
            }
        },
        add() {
            this.editedItem.products.push(this.createProduct());
        },
        remove(index) {
            this.editedItem.products.splice(index, 1);
        },
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        saveProvider(){
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/providers",Object.assign(this.createProvider)).then(()=>{
                this.$store.dispatch('provider/getProviders')
                this.disable = true
                this.createProvider.name=''
            }) 
        },
         uploadSuccess(file, response) {
            this.pdf = file
            console.log('File Successfully Uploaded with file name: ' + response.file);
            this.fileName = response.file;
            this.editedItem.pdf = this.fileName;
        },
        uploadSuccess2(file, response) {
            this.xml = file
            console.log('File Successfully Uploaded with file name: ' + response.file);
            this.fileName = response.file;
            this.editedItem.xml = this.fileName;
        },
        uploadError() {
            console.log('An Error Occurred');
        },
        fileRemoved() {
            
        },
        close () {
            this.e1 = 1
            if(this.pdf!=''){
                this.$refs.myVueDropzone.removeFile(this.pdf)
            }
            if(this.xml!=''){
                this.$refs.myVueDropzone2.removeFile(this.xml)
            }
            this.gris = false
            this.editedItem = {
                date:'',
                serie:'',
                provider_id:'',
                invoice:'',
                due_date:'',
                notes:'',
                pdf:'',
                xml:'',
                created_by_user_id:'',
                last_updated_by_user_id:'',
                global_discount:'',
                products:[this.createProduct({ discount:'' })],
                iva_percentage:0,
                isr_percentage:0
            }
            this.$nextTick(() => {
                this.$emit("closeDialogCreateShopping", false);
                this.$store.dispatch('shopping/getShoppings')
            })
        },
        save () {
            this.gris = true
            if(this.iva_percentage==''||this.iva_percentage==undefined||this.iva_percentage){
                this.iva_percentage = 0
            }
            if(this.isr_percentage==''||this.isr_percentage==undefined||this.isr_percentage){
                this.isr_percentage = 0
            }
            this.editedItem.created_by_user_id = this.currentUser.id
            this.editedItem.last_updated_by_user_id = this.currentUser.id

            this.editedItem.products = this.editedItem.products.map(product => {
                    return{
                        ...product,
                        item_id: JSON.parse(product.item_id).id,
                        original_cost: this.round4(product.original_cost),
                        unit_cost: this.discountedUnitCost(product),
                        apply_iva: product.apply_iva ? 1 : 0
                    }
                })

            const payload = {
                ...this.editedItem
            }
            delete payload.global_discount

            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/shoppings", payload).then(()=>{
                this.$store.dispatch('shopping/getShoppings')
                this.close()
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
                this.gris = false
            })
        },
    },
    created() {
        this.debounceSearch = debounce(this.searchData, 1000);
    }
}
</script>
<style>
.calculos .v-text-field__details{
    display: none!important;
}
.item-hover:hover{
    background: #00000008;
}
.shopping-summary-line{
    display:flex;
    justify-content:space-between;
    gap:12px;
    font-size:13px;
    margin-bottom:4px;
}
.shopping-summary-line--discount{
    color:#c62828;
}
.shopping-summary-line--final{
    margin-top:8px;
    padding-top:8px;
    border-top:1px solid #0000001f;
    font-size:14px;
}
.shopping-summary-note{
    font-size:12px;
    color:#616161;
    margin-bottom:6px;
}
</style>
